import { render, staticRenderFns } from "./edit-password-form.vue?vue&type=template&id=29709d90"
import script from "./edit-password-form.vue?vue&type=script&lang=js"
export * from "./edit-password-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports